import React from 'react';
import LoginRedeem from '../features/auth/components/LoginRedeem';

const LoginRedeemPage = () => {
    return <LoginRedeem />;
};

export default LoginRedeemPage;
